/**
 * @file This component is to show the license agreement page
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import React from 'react';
import 'antd/dist/antd.css';
import { Select, Button, Checkbox, Alert } from 'antd';
import './LicenseAgreePage.css';
import {
    WINDOWS,
    LINUX,
    M11_4_12,
    M11_5_03,
    M11_5_06,
    M11_5_09,
    M11_5_12,
    M11_6_03,
    M11_6_06,
    M11_6_09,
    CUSTOM_INSTALL,
    EXPRESS_INSTALL,
} from '../../../Utils/Constants';

const { Option } = Select;

const licenseAgreePage = (props) => {
    /**
     *
     * @param {String} useOs the Operating System that selected
     * @param {String} useVersion the Version that selected
     * @return {Boolean} true, show the mode dropdown;  false, do noe show it
     */
    let showMode = (useOs, useVersion) => {
        return (
            useOs === WINDOWS &&
            (
                useVersion === M11_4_12 ||
                useVersion === M11_5_03 ||
                useVersion === M11_5_06 ||
                useVersion === M11_5_09 ||
                useVersion === M11_5_12 ||
                useVersion === M11_6_03 ||
                useVersion === M11_6_06 ||
                useVersion === M11_6_09
            )
        );
    };

    let modeSelection = showMode(props.useOs, props.useVersion) ? (
        <div className="inputBox">
            Choose Strategy One Installation Mode:
            <br />
            <Select
                style={{ width: 400 }}
                defaultValue={props.getOriginState('mode')}
                onChange={(value) => {
                    props.setOriginState('mode', value);
                }}
            >
                <Option value={CUSTOM_INSTALL}>Custom</Option>
                <Option value={EXPRESS_INSTALL}>Express</Option>
            </Select>
        </div>
    ) : null;

    let res = (
        <div>
            <div className="licensePage">
                <Checkbox
                    className="license-agree-check-box"
                    onChange={(e) => {
                        props.setOriginState('agreeLicense', e.target.checked);
                    }}
                    checked={props.getOriginState('agreeLicense')}
                >
                    I've read and agree with{' '}
                    <a
                        href="https://www.microstrategy.com/us/legal-folder/legal-policies/terms-of-use"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms of Use
                    </a>
                </Checkbox>
                <div className="inputBoxesContainer">
                    <div className="operationSys">
                        Choose Targeted Operating System:
                        <br />
                        <Select
                            style={{ width: 400 }}
                            defaultValue={props.useOs}
                            onChange={(value) => {
                                props.setOriginState('operateSystem', value);
                            }}
                        >
                            <Option value={WINDOWS}>Windows</Option>
                            <Option value={LINUX}>Linux</Option>
                        </Select>
                    </div>
                    <div className="inputBox">
                        {' '}
                        Strategy One Platform Releases:
                        <br />
                        <Select
                            style={{ width: 400 }}
                            defaultValue={props.getOriginState(
                                'installVersion'
                            )}
                            onChange={(value) => {
                                props.setOriginState('installVersion', value);
                            }}
                        >
                            <Option value={M11_6_09}>
                                September 2026
                            </Option>
                            <Option value={M11_6_06}>
                                June 2026
                            </Option>
                            <Option value={M11_6_03}>
                                March 2026
                            </Option>
                            <Option value={M11_5_12}>
                                December 2025
                            </Option>
                            <Option value={M11_5_09}>
                                September 2025
                            </Option>
                            <Option value={M11_5_06}>
                                June 2025
                            </Option>
                            <Option value={M11_5_03}>
                                March 2025
                            </Option>
                            <Option value={M11_4_12}>
                                December 2024
                            </Option>
                        </Select>
                    </div>
                    {modeSelection}
                </div>
            </div>
            <div className="buttonBar">
                <div className="description">
                    You are creating a configuration file for
                    <img
                        src={
                            props.useOs === WINDOWS
                                ? require('../../../assets/Icons/Windows.png')
                                : require('../../../assets/Icons/Linux.png')
                        }
                        alt="Operating System"
                    />
                </div>
                <div className="buttons">
                    <Button
                        className="buttonNext"
                        type="primary"
                        onClick={() =>
                            props.setOriginState('initialPage', false)
                        }
                        disabled={!props.getOriginState('agreeLicense')}
                    >
                        Next
                    </Button>
                </div>
            </div>
        </div>
    );

    return res;
};

export default licenseAgreePage;
